import { List } from 'immutable';
import React from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { EventCashinOffers } from '@/cashins/views/CashinOffers';
import { firstToUpperCase } from '@/common/client';
import Accordion from '@/common/components/Accordion';
import BackToTop from '@/common/components/BackToTop';
import immutableMemo from '@/common/immutableMemo';
import BettingInfo from '../components/BettingInfo';
import { InstanceInfo } from './live/InstanceInfo';
import MatchTickets from './ticket/MatchTickets';
import { PrematchDetailBetTips } from './Tips';
import MarketCategoriesWrapper from '@/turbo-live/components/MarketCategoriesWrapper';
import {
    detailMarketIds$$,
    marketCollapseAll$,
    prematchCombBetIdsForMarket$$,
    selectedMarketCategoryId$
} from 'nike-ui/src/components/turboLive/push/detail/subs';
import { loggedIn$ } from '@/account/subs';
import { currentPicks$ } from 'nike-ui/src/components/betslip/command';
import { computeCombinableBets } from 'nike-ui/src/components/combinable-bets/handlers';
import { COMBINABLE_BETS } from 'nike-ui/src/components/turboLive/components/detail/MarketCategories';
import InfoMsg from 'nike-ui/src/components/turboLive/components/InfoMsg';
import i18n from '@i18n';
import { CashinPosition } from 'nike-ui/src/components/turboLive/components/cashin/constants';
import CashinPositionContext from 'nike-ui/src/common/CashinPositionContext';

currentPicks$.subscribe(() => {
    dispatch(computeCombinableBets());
});

const PrematchDetailBets = ({ detailData, betbookActive, nikeTvActive = false, promoActive = false }) => {
    const { derefSub } = useReframe();
    const marketCategoryId = derefSub(selectedMarketCategoryId$);
    const marketIds = derefSub(detailMarketIds$$(marketCategoryId)) || List();
    const eventId = detailData.getIn(['sportEvent', 'sportEventId']);
    const selectedBetsHierarchy = detailData.getIn(['box', 'selectedBetsHierarchy', eventId]);
    const showCombinableMsg = marketCategoryId === COMBINABLE_BETS && marketIds.size === 0;

    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);

    return (
        <div className="layout-offer-detail-rw">
            {!betbookActive && !nikeTvActive ? (
                <>
                    <MatchTickets eventId={eventId} />
                    <CashinPositionContext.Provider
                        value={{ cashinPosition: CashinPosition.PREMATCH_DETAIL }}
                        key={eventId}
                    >
                        <EventCashinOffers eventId={eventId} />
                    </CashinPositionContext.Provider>
                </>
            ) : null}
            <MarketCategoriesWrapper matchId={eventId} />
            {showCombinableMsg ? (
                <div className="flex-1 px-10">
                    <InfoMsg>{i18n('nui.marketCategories.noMoreCombinations')}</InfoMsg>
                </div>
            ) : (
                selectedBetsHierarchy?.map((data, i) =>
                    data.map(a =>
                        a.get('betHeaders').map(d => {
                            const marketId = d.getIn(['sportEvents', 0, 'marketId']);
                            const selectedMarket = marketIds.includes(marketId);
                            return selectedMarket ? (
                                <MarketAccordion
                                    key={marketId + d.get('header')}
                                    groupData={d}
                                    showTickets={loggedIn}
                                    betbookMarkete
                                    isFirst={i === 0}
                                    betbookActive={betbookActive}
                                />
                            ) : null;
                        })
                    )
                )
            )}
            {!betbookActive && !promoActive ? <BettingInfo /> : null}
            {selectedBetsHierarchy?.size > 10 && !betbookActive && !promoActive ? <BackToTop /> : null}
        </div>
    );
};

export default immutableMemo(PrematchDetailBets);

const MarketAccordion = immutableMemo(function MarketAccordion({ groupData, isFirst, showTickets, betbookActive }) {
    const derefSub = useReframe();
    const marketId = groupData.getIn(['sportEvents', 0, 'marketId']);
    const expanded = betbookActive ? isFirst : !derefSub(marketCollapseAll$(marketId));
    const combinableBets = derefSub(prematchCombBetIdsForMarket$$(marketId, 'detail'));
    const title = (
        <>
            {!betbookActive ? <SpecialInstanceInfo marketId={marketId} /> : null}
            <span>{firstToUpperCase(groupData.get('headerDetail'))}</span>
        </>
    );

    return (
        <Accordion
            title={title}
            expanded={expanded}
            trackingData={{ category: 'Ponuka', action: `${groupData.get('headerDetail')} $STATE`, label: 'Markety' }}
        >
            <div className="nikeone-match">
                {groupData
                    .get('sportEvents')
                    .map(sportEvent => (
                        <PrematchBets
                            betIds={sportEvent.get('betIds')}
                            combinableBetsFilteredIds={combinableBets}
                            showTickets={showTickets}
                            betbookActive={betbookActive}
                            key={sportEvent.get('betIds')}
                        />
                    ))
                    .toArray()}
            </div>
        </Accordion>
    );
});

const PrematchBets = ({ betIds, combinableBetsFilteredIds, showTickets, betbookActive }) => {
    return betIds
        .filter(betId => !(combinableBetsFilteredIds && !combinableBetsFilteredIds.contains(betId)))
        .map(betId => (
            <PrematchDetailBetTips key={betId} betId={betId} showTickets={showTickets} betbookActive={betbookActive} />
        ));
};

function SpecialInstanceInfo({ marketId }) {
    const derefSub = useReframe();
    const tooltip = derefSub(['nikeone.detail.market.tooltip', marketId]);
    return tooltip ? <InstanceInfo text={tooltip} /> : null;
}
